import { Countries } from '@/utils/language'

const TRACKING_HOST = 'https://abr.ge'

const trackingQueries: Record<Countries, Record<string, string>> = {
  [Countries.KR]: {
    og_tag_id: '17832429',
    routing_short_id: 'r4rmmm',
    tracking_template_id: '05f7d63a3e1c0e4c3f91917443702533',
    ad_type: 'click',
  },
  [Countries.JP]: {
    og_tag_id: '17832431',
    routing_short_id: '8g4rq',
    tracking_template_id: '4eb29d9c61b777487947687aa95b9e83',
    ad_type: 'click',
  },
  [Countries.US]: {
    og_tag_id: '170516948',
    routing_short_id: 'xeao6l',
    tracking_template_id: 'bc4600ba26c0ef0c7bc8c2cb4886eb27',
    ad_type: 'click',
  },
  [Countries.TH]: {
    og_tag_id: '170210288',
    routing_short_id: 'gxvjoo',
    tracking_template_id: '6c516857ac7b928d4318b61c69cecb40',
    ad_type: 'click',
  },
  [Countries.CN]: {},
  [Countries.TW]: {},
}
export function getAirbridgeTrackingLink({ key, channelName }: { key: Countries; channelName: string }): string {
  // URL 객체 생성
  const url = new URL(`/@gangnamunni/${channelName}`, TRACKING_HOST)

  // query 파라미터 추가
  const query = trackingQueries[key]
  Object.entries(query).forEach(([key, value]) => {
    url.searchParams.append(key, value)
  })

  return url.href
}
